import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import StatusMessage from '../StatusMessage';


const propTypes = {
    message: PropTypes.string,
    variant: PropTypes.string,
    handleClose: PropTypes.func,
};

const ModalStatusMessage = ({ message, variant, handleClose }) => {
    return (
        <div style={{ textAlign: 'center' }}>
            <StatusMessage message={message} variant={variant} />
            <br />
            <br />
            <Button onClick={handleClose}>
                Close popup
            </Button>
        </div>
    );
};

ModalStatusMessage.propTypes = propTypes;

export default ModalStatusMessage;
